var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"order-item"},[_c(_vm.componentToRender,{tag:"div",attrs:{"item":_vm.item,"showhotels":_vm.showhotels}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }